export enum LocalStorageKeys {
    ACCESS_TOKEN = "access_token",
    USER_ROLE = "user_role",
    USER_ID = "user_id"
}